import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { primary } from '../../assets/colors.js';
import { PlayfairDisplay } from '../../assets/fonts.js';

var _templateObject;
var titleSizes = {
  sm: 24,
  md: 32,
  lg: 40
};
var TitleDefinition = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  color: ", ";\n"])), PlayfairDisplay, function (props) {
  return "".concat(titleSizes[props.size] || 24, "px");
}, primary);
TitleDefinition.displayName = "Title";
TitleDefinition.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"])
};

export { TitleDefinition as default };
